export default __webpack_public_path__ + "static/media/467.9106baab.png";